import api from '../../../../app/ApiConfig';
import { Apis } from '../../../../config';
import { NotificationManager } from 'react-notifications';

const getProductById = async (id) => {
    try {
        let result = await api.get(Apis.GetProductById+id);
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        return result.data;
    } catch (error) {
        console.log(error);
        return null;
    }
};

const getTopSellersById = async (id) => {
    try {
        let result = await api.get(Apis.GetTopSellers+id);
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        return result.data;
    } catch (error) {
        console.log(error);
        return null;
    }
};

const downloadCategoryPDF = async (categoryName) => {
    try {
        const response = await api.post(Apis.DownloadCategoryPdf, { categoryName }, {
            responseType: 'blob', // Ensure the response is treated as a file
        });
        console.log(response)

        if (response.data) {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${categoryName}.pdf`;
            link.click();

            // Release the object URL after download
            window.URL.revokeObjectURL(url);
        } else {
            NotificationManager.error("Failed to download PDF");
        }
    } catch (error) {
        console.error("Error:", error);
        NotificationManager.error("An error occurred while downloading the PDF.");
    }
};



const getProductByCategory = async (categoryId) => {
    try {
      // Make sure to include categoryId in the URL as a query parameter
      let result = await api.get(`${Apis.GetProductByCategory}?categoryId=${categoryId}`);
  
      if (result.data.error) {
        NotificationManager.error(result.data.error);
        return null;
      }
  
      return result.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };
  

const getProductByTagSearch= async (tag) => {
    try {
      // Make sure to include tag in the URL as a query parameter
      let result = await api.get(`${Apis.GetProductByTagSearch}?tag=${tag}`);
  
      if (result.data.error) {
        NotificationManager.error(result.data.error);
        return null;
      }
  
      return result.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };


 const getAllProductQuerySearchList = async (q) => {
    try {
        let result = await api.get(Apis.GetProductQuerySearchList+q);
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        return result.data;
    } catch (error) {
        console.log(error);
        return null;
    }
};


const getNewArrivals= async (limit) => {
    try {
      // Make sure to include limit in the URL as a query parameter
      let result = await api.get(`${Apis.GetNewProductArrivals}`);
  
      if (result.data.error) {
        NotificationManager.error(result.data.error);
        return null;
      }
  
      return result.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };




export default {
    getProductById,
    getProductByCategory,
    getProductByTagSearch,
    getNewArrivals,
    getTopSellersById,
    getAllProductQuerySearchList,
    downloadCategoryPDF
};